<div class="slider-container">
    <div class="popover-header">{{title}}</div>
    <ng-container *ngIf="optionsSet">
        <div class="custom-slider">
            <ng-container *ngIf="content.isHeader;else normalText">
                <ngx-slider
                    [(value)]="value"
                    [options]="headerOptions"
                    (userChangeStart)="onUserChangeStart($event)"
                    (userChange)="onUserChange($event)"
                    (userChangeEnd)="onUserChangeEnd($event)">
                </ngx-slider>
            </ng-container>
            <ng-template #normalText>
                <ngx-slider
                    [(value)]="value"
                    [options]="options"
                    (userChangeStart)="onUserChangeStart($event)"
                    (userChange)="onUserChange($event)"
                    (userChangeEnd)="onUserChangeEnd($event)">
                </ngx-slider>
            </ng-template>
            
        </div>
    </ng-container>
<!--     <div class="popover-footer">
        <button nbButton size="tiny" (click)="onSubmit()">Apply</button>
    </div> -->
</div>
